import { Box, TextField } from '@mui/material'
import { type fplSettings } from '../../core/types'

interface ProgramAgeSettingProps {
  record: fplSettings
  onChange: (record: fplSettings) => void
}

export function ProgramAgeSetting (props: ProgramAgeSettingProps): JSX.Element {
  const handleChange = (e: any): void => {
    const values = { ...props.record, [e.target.name]: e.target.value }
    props.onChange(values)
  }

  return <>
    <Box >
      <TextField
        name='fplIncomeThreshhold'
        type='number'
        sx={{ width: '100px' }}
        value={props.record.fplIncomeThreshhold}
        required={true}
        onChange={handleChange}
      />
    </Box>
  </>
}
